module.exports = __webpack_public_path__ + "img/ShowMeVegasSlotsLogo.55b7626c.png";